module.exports = __webpack_public_path__ + "static/img/backtop.94947c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/backtop.png
// module id = iNaM
// module chunks = 15